import { notification } from "../services";
const UNAUTHORIZED = 401;
const NOTFOUND = 404;
const BAD_REQUEST = 400;

const responseErros = (res) => {
  let message = "";
  let status = null;
  if (res?.status && res.status != BAD_REQUEST) {
    status = res.status;
    message = res?.statusText;
  } else {
    status = res?.response?.status;
    message = res?.response?.data?.message;
  }
  if (status != UNAUTHORIZED && status != NOTFOUND) {
    if (status == BAD_REQUEST) {
      notification.alertaGenericos(message);
    } else {
      notification.erroInternoServidor();
    }
  }
};

export default responseErros;
